// hooks/usePaymentStatus.js
import { useState, useEffect } from 'react';
import { checkPaymentStatus } from '../services/api.service';
import { useAuth } from '../contexts/AuthContext';

export const usePaymentStatus = () => {
  const [isAccountFrozen, setIsAccountFrozen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { token, user } = useAuth();

  useEffect(() => {
    const checkStatus = async () => {
      try {
        // First check if user data indicates payment is overdue
        if (user?.isPaymentOverdue) {
          setIsAccountFrozen(true);
          setIsLoading(false);
          return;
        }

        // Then check via API
        const paymentStatus = await checkPaymentStatus(token);
        setIsAccountFrozen(paymentStatus.isOverdue);
      } catch (error) {
        console.error('Error checking payment status:', error);
        // Default to not frozen if check fails
        setIsAccountFrozen(false);
      } finally {
        setIsLoading(false);
      }
    };

    if (token && user) {
      checkStatus();
    }
  }, [token, user]);

  const showFrozenAlert = (showAlert) => {
    showAlert(
      'Your account is currently frozen due to overdue payment. Please visit My Profile > Account to make payment and restore full access.',
      'danger'
    );
  };

  return { isAccountFrozen, isLoading, showFrozenAlert };
};